import { Component } from 'react'
import { Layout } from 'antd';
import { UserOutlined } from '@ant-design/icons';

const { Header } = Layout;

export default class header extends Component {
  render() {
        return (
        <Header style={{
            background: '#001529',
            padding: '0 24px',
            display: 'flex',
            alignItems: 'center'
          }}>
            <div style={{
              color: '#fff',
              fontSize: '20px',
              fontWeight: 'bold'
            }}>
              <UserOutlined style={{ marginRight: 12 }} />
              AWS Marketplace Backend Managed System
            </div>
          </Header>
        )
    }
}
